import { useState } from 'react';

import { Button, HStack, Label, VStack } from '@betterment/samba-react';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { PurposeIconSelector } from '../../Shared/components-v2/purpose-icon-selector/PurposeIconSelector';

import type { ThemedAsset } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

type ImageSelectorProps = {
  themedAsset: ThemedAsset;
  alt: string;
};

export const ImageSelector: React.FC<ImageSelectorProps> = ({ themedAsset, alt }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <VStack css={{ gap: 'space.100' }}>
      <Label>Goal image</Label>
      {isExpanded ? (
        <PurposeIconSelector />
      ) : (
        <HStack css={{ gap: 'space.200', alignItems: 'center' }}>
          <ThemedImage themedAsset={themedAsset} alt={alt} />
          <Button onClick={() => setIsExpanded(true)} variant="textPrimary">
            Change or upload
          </Button>
        </HStack>
      )}
    </VStack>
  );
};
